import React, { useEffect, useState, useCallback, useRef } from "react";
import { Col, Row, Overlay, Button, Popover } from "react-bootstrap";
import { connect } from "react-redux";
import { Formik, Form } from "formik";
import { VzPageContainer } from "../../../layouts/VzPageContainer";
import FormikControl from "../../../layouts/Input/FormikControl";
import storage from "../../../apis/Storage";
import { toCommaSeparated } from "../../../utilities/FUNCTIONS";

import {
  GET_DISTRIBUTIONCENTER_DDL,
  GET_DISTRIBUTOR_DDL,
  GET_RSOS_DDL,
  GET_CITIES,
} from "../../../Types";

import {
  getDropdownList,
  getDropdownListByPost,
} from "../../Shared/dropdownListActions";
import { Link } from "react-router-dom";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  OverlayView,
} from "@react-google-maps/api";
import { getVfoTrackReportData } from "./VfoTrackReportAction";
import {
  formatDate,
  getDefaultCoordinates,
} from "../../../utilities/FUNCTIONS";
import _ from "lodash";
import { toast } from "react-toastify";

const CustomMarker = ({
  position,
  name,
  shop,
  timing,
  remarks,
  isDetailVisible,
  onDrag,
  index,
  onTimingClick,
}) => {
  const [markerPos, setMarkerPos] = useState(position);

  useEffect(() => {
    setMarkerPos(position);
  }, [position]);

  return (
    <>
      <Marker
        position={markerPos}
        icon="https://maps.google.com/mapfiles/ms/icons/red-dot.png"
        draggable={true}
        onDragEnd={(e) => {
          const newPos = {
            lat: e.latLng.lat(),
            lng: e.latLng.lng(),
          };
          setMarkerPos(newPos);
          onDrag(newPos, index); // pass to parent
        }}
        onClick={() => onTimingClick(position)}
        title={name}
      />

      {timing && (
        <OverlayView
          position={markerPos}
          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
        >
          <div
            style={{
              transform: "translate(-50%, -265%)",
              backgroundColor: "#f39c12",
              padding: "2px 6px",
              borderRadius: "4px",
              fontSize: "12px",
              fontWeight: "500",
              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.3)",
              whiteSpace: "nowrap",
              border: "0.5px solid black",
              width: "90px",
            }}
          >
            {timing}
          </div>
        </OverlayView>
      )}
    </>
  );
};

const Legend = ({ sectors, shops, agents }) => {
  return (
    <div className="legend px-3" style={{ marginTop: "35px" }}>
      <div className="legend-item">
        <div className="legend-icon legend-sector"></div>
        <div className="legend-label">Sector {sectors}</div>
      </div>
      <div className="legend-item">
        <div className="legend-icon legend-shop"></div>
        <div className="legend-label">Shop {shops}</div>
      </div>
    </div>
  );
};

const polygonsMap = new Map();

const createPolygon = (
  map,
  polygonCoords,
  sectorId,
  onPolygonClick,
  options = {},
) => {
  // Remove existing polygon with the same sectorId
  if (polygonsMap.has(sectorId)) {
    polygonsMap.get(sectorId).setMap(null);
  }

  const polygon = new window.google.maps.Polygon({
    paths: polygonCoords,
    strokeColor: "#FF0000",
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: "#FF0000",
    fillOpacity: 0.35,
    clickable: true,
    ...options,
  });

  polygon.setMap(map);
  polygonsMap.set(sectorId, polygon);

  polygon.addListener("click", (e) => {
    onPolygonClick();
  });

  return polygon;
};

const containerStyle = {
  height: "80vh",
  width: "100%",
};

function spreadOverlappingMarkers(markers) {
  const grouped = {};
  const offset = 0.000005; // ~5-6 meters

  markers.forEach((shop) => {
    const key = `${shop.lat},${shop.long}`;
    if (!grouped[key]) {
      grouped[key] = [];
    }
    grouped[key].push(shop);
  });

  const adjusted = [];

  for (const group of Object.values(grouped)) {
    if (group.length === 1) {
      adjusted.push(group[0]);
    } else {
      // Spread them in a circle
      const centerLat = parseFloat(group[0].lat);
      const centerLng = parseFloat(group[0].long);
      const angleStep = (2 * Math.PI) / group.length;

      group.forEach((shop, index) => {
        const angle = index * angleStep;
        adjusted.push({
          ...shop,
          lat: centerLat + Math.sin(angle) * offset,
          long: centerLng + Math.cos(angle) * offset,
          _isAdjusted: true,
        });
      });
    }
  }

  return adjusted;
}

const MemoizedMap = React.memo(
  ({
    shopsList,
    selectedSector,
    selectedShop,
    selectedCityCoords,
    onShopClick,
    onMapClick,
    defaultCoordinates,
  }) => {
    const [map, setMap] = useState(null);
    const [mapInstance, setMapInstance] = useState(null);
    const hasInitializedMap = useRef(false);
    const [adjustedShopsList, setAdjustedShopsList] = useState(
      spreadOverlappingMarkers(shopsList),
    );

    const [center, setCenter] = useState({
      lat: parseFloat(
        selectedSector.length === 1
          ? selectedSector[0].poligonPoint1.split(",")[1]
          : defaultCoordinates.lat,
      ),
      lng: parseFloat(
        selectedSector.length === 1
          ? selectedSector[0].poligonPoint1.split(",")[0]
          : defaultCoordinates.lng,
      ),
    });

    const { isLoaded } = useJsApiLoader({
      id: "google-map-script",
      // googleMapsApiKey: "AIzaSyCxx8pID_k9_wAbQI_oYL9yYfhlfJntAs4",
      googleMapsApiKey: "AIzaSyDqs07ua04jy-Zz_nYm6GMvOo6WgKZrWNI",
    });

    const handleMapLoad = useCallback(
      (map) => {
        if (!hasInitializedMap.current) {
          setMapInstance(map);
          hasInitializedMap.current = true;
        }
      },
      [selectedSector, shopsList],
    );

    const onUnmount = useCallback(() => setMap(null), []);

    const handlePolygonClick = useCallback(() => {
      onShopClick(null);
    }, []);

    useEffect(() => {
      polygonsMap.forEach((polygon) => polygon.setMap(null));
      polygonsMap.clear();

      if (mapInstance && selectedSector?.length > 0) {
        selectedSector.forEach((sector) => {
          const polygons = [];
          for (let i = 1; i <= 5; i++) {
            const point = sector[`poligonPoint${i}`];
            if (point) {
              const [lng, lat] = point.split(",").map(parseFloat);
              if (!isNaN(lat) && !isNaN(lng)) {
                polygons.push({ lat, lng });
              }
            }
          }

          if (polygons.length >= 3) {
            createPolygon(
              mapInstance,
              polygons,
              sector.id || sector.name,
              handlePolygonClick,
            );
          }
        });
      }
    }, [mapInstance, selectedSector, shopsList]);

    const lineRef = useRef(null);
    // const [shopMarkers, setShopMarkers] = useState(shopsList);

    useEffect(() => {
      if (mapInstance && adjustedShopsList.length >= 2) {
        if (lineRef.current) {
          lineRef.current.setMap(null);
        }

        const pathCoordinates = adjustedShopsList.map((shop) => ({
          lat: parseFloat(shop.lat),
          lng: parseFloat(shop.long),
        }));

        const newLine = new window.google.maps.Polyline({
          path: pathCoordinates,
          geodesic: true,
          strokeColor: "#0000FF",
          strokeOpacity: 1.0,
          strokeWeight: 4,
        });

        newLine.setMap(mapInstance);
        lineRef.current = newLine;
      }
      // return () => {
      //   if (lineRef.current) {
      //     lineRef.current.setMap(null);
      //     lineRef.current = null;
      //   }
      // };
    }, [mapInstance, adjustedShopsList]);

    useEffect(() => {
      setAdjustedShopsList(spreadOverlappingMarkers(shopsList));
    }, [mapInstance, shopsList]);

    useEffect(() => {
      if (selectedCityCoords != null) {
        setCenter({
          lat: parseFloat(selectedCityCoords.lat),
          lng: parseFloat(selectedCityCoords.lng),
        });
      }
    }, [selectedCityCoords]);

    const handleMarkerDrag = (newPos, index) => {
      const updated = [...adjustedShopsList];
      updated[index] = {
        ...updated[index],
        lat: newPos.lat,
        long: newPos.lng,
      };
      setAdjustedShopsList(updated); // triggers polyline update
    };

    return isLoaded ? (
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={15}
        onLoad={handleMapLoad}
        onUnmount={onUnmount}
        onClick={onMapClick}
      >
        {adjustedShopsList.map((item, index) => (
          <CustomMarker
            key={index}
            index={index}
            position={{ lat: item.lat, lng: item.long }}
            timing={item.timing}
            remarks={item.remarks}
            name={item.vizId}
            shop={item.shopName}
            isDetailVisible={selectedShop?.vizId === item.vizId}
            onTimingClick={(e) => {
              const _center = mapInstance?.getCenter?.();
              setCenter(_center);
              onShopClick(item);
            }}
            onDrag={(pos) => handleMarkerDrag(pos, index)}
          />
        ))}

        {selectedShop && (
          <OverlayView
            position={{ lat: selectedShop.lat, lng: selectedShop.long }}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          >
            <div
              style={{
                transform: "translate(-50%, -100%)",
                backgroundColor: "white",
                padding: "8px",
                borderRadius: "8px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                width: "230px",
                fontSize: "12px",
                zIndex: 10,
                marginLeft: "170px",
              }}
            >
              <div>
                <strong>Viz Id:</strong> {selectedShop.vizId}
              </div>
              <div>
                <strong>Shop:</strong> {selectedShop.shopName}
              </div>
              <div>
                <strong>Remarks:</strong> {selectedShop.remarks}
              </div>
            </div>
          </OverlayView>
        )}
      </GoogleMap>
    ) : null;
  },
);

const VfoTrackReport = (props) => {
  const userRights = JSON.parse(storage.get("_userRights"));
  const [target, setTarget] = useState(null);
  const [show, setShow] = useState(false);
  const ref = useRef(null);

  const [distributorList, setDistributorList] = useState([]);
  const [distCenterList, setdistCenterList] = useState([]);
  const [isApplyFilter, setIsApplyFilter] = useState(false);

  const [selectedSector, setSelectedSector] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [shopsList, setShopsList] = useState([]);
  const [selectedShop, setSelectedShop] = useState(null);
  const [selectedCityCoords, setSelectedCityCoords] = useState(null);

  const _coord = getDefaultCoordinates();

  const [filter, setfilter] = useState({
    city: null,
    rso: null,
    distributor: [],  
    distCenter: [],
    fromDate: new Date(),
    toDate: new Date(),
  });

  const [activeInfoPosition, setActiveInfoPosition] = useState({});

  const openFilterModal = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  function commonReset(reset = true) {
    if (reset) {
      setSelectedSector([]);
      setSearchText("");

      setfilter({
        city: null,
        rso: null,
        distributor:
          userRights != null && userRights?.userType == "DistributorUser"
            ? filter.distributor?.length > 0
                ? toCommaSeparated(filter.distributor)
                : null
            : null,
        distCenter: [],
        fromDate: new Date(),
        toDate: new Date(),
      });

      setSelectedCityCoords({
        lat: _coord.lat,
        lng: _coord.lng,
      });
    }
  }

  function formRequestObject() {
  let requestData = {
    cityId: filter.city?.value,
    rsoId: filter.rso?.value,
    // ✅ convert array → comma string
      distributorId:
            filter.distributor?.length > 0
                ? toCommaSeparated(filter.distributor)
                : null,
      distCenterId:
            filter.distCenter?.length > 0
                ? toCommaSeparated(filter.distCenter)
                : null,
    searchText: searchText,
    fromDate: filter.fromDate && formatDate(filter.fromDate),
    toDate: filter.fromDate && formatDate(filter.toDate),
  };

  if (userRights != null && userRights?.userType == "DistributorUser") {
    requestData.distributorId = userRights.distributorId;
  }

  return requestData;
}

  const handleResetFilters = (resetForm) => {
    resetForm();
    commonReset();
  };

  function fetchReportData(request) {
    let finalRequest = request == null ? formRequestObject() : request;
    props.getVfoTrackReportData(finalRequest);
  }

  const LoadDataByfilter = (event) => {
    var request = { ...formRequestObject() };

    if (!filter.rso || filter.rso.length == 0) {
      setShopsList([]);
      setSelectedSector([]);
    } else {
      fetchReportData(request);
      setShow(false);
      setIsApplyFilter(true);
    }
  };

  useEffect(() => {
    props.getDropdownList(
      `api/Distributor/GetDistributorsDDL`,
      GET_DISTRIBUTOR_DDL,
    );
  }, []);

  useEffect(() => {
    props.getDropdownList(`api/City`, GET_CITIES);
  }, []);

  useEffect(() => {
    if (userRights != null && userRights?.userType == "DistributorUser") {
      let distributorList = props.allDistributorList.filter(
        (x) => x.value == userRights?.distributorId,
      );
      if (distributorList?.length > 0) {
        setfilter({
          ...filter,
          distributor: {
            label: distributorList[0]?.label,
            value: distributorList[0]?.value,
          },
        });
      }
      setDistributorList(
        distributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        }),
      );
    } else {
      setDistributorList(
        props.allDistributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        }),
      );
    }
  }, [props.allDistributorList]);

  useEffect(() => {
    if (userRights != null && userRights?.userType == "DistributorUser") {
      let distCenterList = props.selectedDistCentersList.filter((x) =>
        userRights?.distCenterIds.includes(x.value),
      );
      setdistCenterList(
        distCenterList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        }),
      );
    } else {
      setdistCenterList(
        props.selectedDistCentersList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        }),
      );
    }
  }, [props.selectedDistCentersList]);

  useEffect(() => {
    if (filter.distributor?.length > 0) {
      var Ids = toCommaSeparated(filter.distributor);
      props.getDropdownListByPost(
        `api/DistCenter/GetDistCentersDDL`,
        { distributorIds:  Ids},
        GET_DISTRIBUTIONCENTER_DDL
      );
    }
  
    setfilter((prev) => ({
      ...prev,
      distCenter: [],
    }));
  }, [filter.distributor]);

  useEffect(() => {
    props.getDropdownList(`api/User/GetRSODDL`, GET_RSOS_DDL);
  }, []);

  useEffect(() => {
    setShopsList(props.VfoTrackReport?.shops ?? []);
    setSelectedSector(props.VfoTrackReport?.sectors ?? []);
  }, [props.VfoTrackReport]);

  return (
    <div>
      <VzPageContainer title="VFO Track Report">
        <Row>
          <Col style={{ float: "left" }}>
            <h4>
              <b>VFO Track Report</b>
            </h4>
          </Col>
        </Row>
        <Row>
          <Col md={9} style={{ float: "right" }}>
            <div ref={ref}>
              <Button
                onClick={openFilterModal}
                className="m-3"
                variant="outline-primary"
              >
                <i className="fa fa-filter" />
                Filters
              </Button>

              <Overlay
                show={show}
                target={target}
                placement="bottom"
                container={ref}
                containerPadding={20}
                width="430px"
                style={{ width: "430px" }}
              >
                <Popover
                  id="popover-contained"
                  style={{ maxWidth: "360px", width: "360px" }}
                >
                  <Popover.Header as="h3">Filters</Popover.Header>
                  <Popover.Body>
                    <Formik
                      enableReinitialize
                      initialValues={filter}
                      onSubmit={LoadDataByfilter}
                    >
                      {(formik) => (
                        <Form autoComplete="off">
                          <Row>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="City"
                                name="city"
                                options={props.cities}
                                isClearable={true}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  if (!e || !e.value) {
                                    setfilter({
                                      ...filter,
                                      city: null,
                                    });

                                    setSelectedCityCoords({
                                      lat: _coord.lat,
                                      lng: _coord.lng,
                                    });

                                    return;
                                  }
                                  setfilter({
                                    ...filter,
                                    city: {
                                      label: e.label,
                                      value: e.value,
                                    },
                                  });

                                  if (
                                    e.coords != null &&
                                    e.coords.split(",").length > 1
                                  ) {
                                    setSelectedCityCoords({
                                      lat: e.coords.split(",")[0],
                                      lng: e.coords.split(",")[1],
                                    });
                                  } else {
                                    toast.info(
                                      "Selected City Coordinates Are Missing",
                                    );
                                    setSelectedCityCoords({
                                      lat: _coord.lat,
                                      lng: _coord.lng,
                                    });
                                  }
                                }}
                                value={filter.city}
                              />
                            </Col>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="RSO"
                                name="rso"
                                options={props.rsoUsers}
                                isClearable={true}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  if (!e || !e.value) {
                                    setfilter({
                                      ...filter,
                                      rso: null,
                                    });
                                    return;
                                  }
                                  setfilter({
                                    ...filter,
                                    rso: {
                                      label: e.label,
                                      value: e.value,
                                    },
                                  });
                                }}
                                value={filter.rso}
                              />
                            </Col>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Distributor"
                                name="distributor"
                                options={distributorList}
                                isClearable={true}
                                isSearchable={true}
                                isMulti={true}
                                handleOnChange={(e) => {
                                  setfilter({
                                    ...filter,
                                    distributor: e || []
                                  });
                                }}
                                value={filter.distributor}
                              />
                            </Col>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Distribution Center"
                                name="distCenter"
                                options={
                                  filter.distributor != null
                                    ? distCenterList
                                    : []
                                }
                                isClearable={true}
                                isSearchable={true}
                                isMulti={true}
                                handleOnChange={(e) => {
                                setfilter({
                                  ...filter,
                                  distCenter: e || []
                                });
                              }}
                                value={filter.distCenter}
                              />
                            </Col>
                            <Row style={{ paddingRight: 0 }}>
                              <Col xs={12} md={6}>
                                <FormikControl
                                  formik={formik}
                                  type="fromDate"
                                  control="date"
                                  label="From Date"
                                  name="fromDate"
                                  handleOnChange={(value) => {
                                    setfilter({ ...filter, fromDate: value });
                                  }}
                                  value={filter.fromDate}
                                />
                              </Col>
                              <Col xs={12} md={6}>
                                <FormikControl
                                  // formik={formik}
                                  control="date"
                                  type="toDate"
                                  label="To Date"
                                  name="toDate"
                                  handleOnChange={(value) => {
                                    setfilter({ ...filter, toDate: value });
                                  }}
                                  value={filter.toDate}
                                />
                              </Col>
                            </Row>
                          </Row>
                          <div className="row" style={{ marginTop: 20 }}>
                            <div className="form-group">
                              <Link
                                onClick={handleResetFilters.bind(
                                  null,
                                  formik.resetForm,
                                  setIsApplyFilter(false),
                                )}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "left",
                                }}
                              >
                                Reset
                              </Link>
                              <Link
                                onClick={() => {
                                  setShow(false);
                                  setTarget(null);
                                  commonReset(isApplyFilter);
                                }}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "right",
                                }}
                              >
                                Cancel
                              </Link>
                              <div className="float-right">
                                <Button
                                  type="submit"
                                  className="btn btn-primary"
                                  style={{
                                    marginRight: "10px",
                                    float: "right",
                                  }}
                                >
                                  Apply
                                </Button>
                              </div>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </Popover.Body>
                </Popover>
              </Overlay>
            </div>
          </Col>
          <Col xs={3}></Col>
        </Row>
        <Row>
          <Col xs={12}>
            {/* <Map /> */}
            <MemoizedMap
              shopsList={shopsList}
              selectedSector={selectedSector}
              selectedShop={selectedShop}
              selectedCityCoords={selectedCityCoords}
              onShopClick={(shop) => setSelectedShop(shop)}
              onMapClick={() => setSelectedShop(null)}
              defaultCoordinates={_coord}
            />
          </Col>
        </Row>
      </VzPageContainer>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    VfoTrackReport: state.VfoTrackReport ? state.VfoTrackReport : [],
    allDistributorList: state.ddlList.allDistributorList
      ? state.ddlList.allDistributorList
      : [],
    selectedDistCentersList: state.ddlList.selectedDistCentersList
      ? state.ddlList.selectedDistCentersList
      : [],
    rsoUsers: state.ddlList.rsosList ? state.ddlList.rsosList : [],
    cities: state.ddlList.cities ? state.ddlList.cities : [],
  };
};
export default connect(mapStateToProps, {
  getDropdownList,
  getDropdownListByPost,
  getVfoTrackReportData,
})(VfoTrackReport);
